/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ tokens: NonNullable<unknown> }} Model_Showcase_Context_TokensInputs */



/**
* | output |
* | --- |
* | "{tokens} tokens" |
*
* @param {Model_Showcase_Context_TokensInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const model_showcase_context_tokens = /** @type {((inputs: Model_Showcase_Context_TokensInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Model_Showcase_Context_TokensInputs, { locale?: "en" | "de" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ (`${i?.tokens} Tokens`)
	return /** @type {LocalizedString} */ (`${i?.tokens} tokens`)
});